// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ga from "@store/Framework/Common/GoogleAnalytics";

const mapProductContextModel = (
    productContext: ProductContextModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    if (!options?.productInfos) {
        Object.assign(options, { productInfos: [productContext.productInfo] });
    }

    return ga.map.productModel(productContext.product, options);
};

export default mapProductContextModel;
